import { Stack, Typography } from '@thirdspacelearning/library';

const SessionProgrammeNotAssigned = () => (
    <Stack alignSelf="flex-start" px={4} py={2} gap={2} width="100%">
        <Typography
            variant="h5"
            fontWeight="bold"
            data-testid="noSessionPlannedText"
        >
            Hello! Before we start, please ask your teacher to log on and select
            a programme for you.
        </Typography>
    </Stack>
);

export default SessionProgrammeNotAssigned;
